/** Meme — document knowledge definition. Pure data. */
export default {
  id: 'meme',
  name: 'Meme',
  description: 'A humorous image-and-caption format built for shareability.',
  purpose: 'Humor & Virality',
  recommendedSizes: [{ name: 'Square', width: 1080, height: 1080, unit: 'px' }],
  supportedOrientations: ['square', 'portrait', 'landscape'],
  supportsMultiplePages: false,
  supportsBleed: false,
  supportsImages: true,
  supportsIcons: false,
  supportsQR: false,
  supportsTables: false,
  supportsPricing: false,
  supportsCTA: false,
  supportsOffers: false,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Image', 'Top Text', 'Bottom Text'],
};
